import AssistantMessage from "./AssistantMessage";
import ToolCallResult from "./ToolCallResult";
import "./ActionStepResult.scss";

function isValidJsonArray(str) {
  try {
    const parsed = JSON.parse(str);
    return Array.isArray(parsed);
  } catch (e) {
    return false;
  }
}

const ActionStepResult = ({ step }) => {
  const stepResult = step.stepResult;

  if (!isValidJsonArray(stepResult)) {
    return null;
  }

  const stepResultArray = JSON.parse(stepResult);

  return (
    <div className="action_step_result">
      {stepResultArray.map((result, index) => {
        if (result.role === "assistant") {
          return <AssistantMessage key={index} content={result.content} />;
        } else if (result.role === "user" && result.continuation) {
          return (
            <ToolCallResult
              key={index}
              continuation={result.continuation}
            />
          );
        }
        return null;
      })}
    </div>
  );
};

export default ActionStepResult;
